import React from 'react';
// template components
import BrokerDealerDisclosure from '@nmx/template/dist/componentLibrary/layout/Footer/BrokerDealerDisclosure';

export default () => {
  return (
    <BrokerDealerDisclosure
      sectionId='broker-dealer-disclosure'
      moduleName='broker-dealer-disclosure'
      moduleVariation='A'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding />
  );
};
